import type { TISAUser, Quest } from '@/types/tisa-coins';
import { getQuestStates } from '@/lib/tisa-helpers';

interface Props {
  user: TISAUser;
  quests: Quest[];
  onRefresh: () => void;
}

export function AvailableQuestsSection({ user, quests }: Props) {
  const questStates = getQuestStates(user.quest_events);
  const availableQuests = quests.filter(q => !questStates[q.id]);

  return (
    <div className="bg-gray-900/50 border-2 border-blue-500/30 rounded-xl p-6">
      <h2 className="text-2xl font-cinzel font-bold text-blue-400 mb-4">
        🗺️ Available Quests ({availableQuests.length})
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {availableQuests.slice(0, 6).map(quest => (
          <div key={quest.id} className="bg-black/30 border border-blue-500/20 rounded-lg p-4 hover:border-blue-500/50 transition-all">
            <div className="flex justify-between items-start mb-2">
              <h3 className="font-cinzel font-bold text-white text-sm">{quest.title}</h3>
              <span className="text-emerald font-orbitron font-bold text-sm">{quest.xp_reward} XP</span>
            </div>
            <p className="text-xs text-gray-400 mb-3 line-clamp-2">{quest.description}</p>
            <div className="flex gap-2 items-center justify-between">
              <div className="flex gap-2">
                <span className="px-2 py-1 bg-blue-500/20 text-blue-300 text-xs rounded">{quest.type}</span>
              </div>
              <button className="px-3 py-1 bg-blue-500 text-white rounded text-xs font-bold hover:bg-blue-600">
                Accept
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
